<!-- ---------------------------------- -->
<!-- Header for tablets, laptops and up -->
<!-- ---------------------------------- -->
<header>
	<div class="application-language-header">Welcome to the {{ this.applicationName }} !</div>
	<div class="content-header">
		<div class="header-left-triangle"></div>
		<!-- RT-Logo -->
		<div class="logo-content" [class.opened]="isSidebarOpened">
			<img [src]="smallLogo" alt="Logo" class="logo-img" (click)="goToRootPage()" />
		</div>

		<div class="d-flex align-items-center comparison-file-name">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
				<path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
			</svg>
			<p class="ml-2 mb-0">{{ "header.comparisonFile" | translate }} {{ comparisonName$ | async }}</p>
		</div>

		<!-- Main content -->
		<div class="header-content">
			<!-- Menu button and breadcrumb -->
			<div class="menu-content">
				<!-- Menu button -->
				@if (withSidebar) {
					<button type="button" class="menu-button" (click)="toggleSidebar()">
						<span class="zmdi zmdi-menu"></span>
					</button>
				}
			</div>
			<!-- Other details -->
			<div class="details-content">
				<!-- User details-->
				<p class="user-info mb-0">
					<span class="user-name">{{ this.user.name }}</span>
				</p>
			</div>
		</div>
	</div>
</header>
